import CustomButton from "../../components/custom/button";
import { useAppDispatch } from "../../../app/redux/hooks";
import { showSnackbar } from "../../../app/slices/common/customSnackBar/customSnackbarSlice";
import axios from "../../../axios";
import { useState } from "react";
import { useMediaQuery } from "@mui/material";

export const DeleteAccountModal = ({ modalClose }: any) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const resp: any = await axios.post("accounts/delete/");

      // Accept 200 OK as success
      if (resp?.status === 200 || resp?.data?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Your account has been deleted successfully.",
            severity: "success",
            autoHide: 2000,
          })
        );
        // Clear session and redirect to home
        localStorage.clear();
        modalClose();
        window.location.href = "/shopnow/";
      } else {
        dispatch(
          showSnackbar({
            message: resp?.data?.message || "Please try again later.",
            severity: "error",
            autoHide: 3000,
          })
        );
      }
    } catch (err) {
      dispatch(
        showSnackbar({
          message: "Unable to delete account. Please try again later.",
          severity: "error",
          autoHide: 3000,
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
      style={{
        // padding: "1.5rem 1.25rem 1.25rem",
        textAlign: "center",
        color: "#1f2937",
      }}
    >
      <p
        style={{
          margin: 0,
          padding: 0,
          fontSize: "1rem",
          lineHeight: 1.75,
          color: "#334155",
          textAlign:"left"
        }}
      >{`Are you sure you want to delete your account? This action cannot be undone.`}</p>
      <div
        style={{
          margin: "1.25rem 0 0",
          borderBottom: "1px solid #e2e8f0",
        }}
      />
      <div
      className="d-flex justify-content-end"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: isMobile ? "0.5rem" : "0.75rem",
          marginTop: "1.25rem",
          flexWrap: "nowrap",
        }}
      >
        <CustomButton
          name="Cancel"
          onClick={modalClose}
          color="secondary"
          variant="outlined"
          fullWidth={false}
          style={{
            minWidth: isMobile ? 130 : 110,
            padding: "0.5rem 1rem",
          }}
        />
        <CustomButton
          name="Yes"
          onClick={handleDelete}
          fullWidth={false}
          style={{
            minWidth: isMobile ? 140 : 120,
            padding: "0.5rem 1.1rem",
          }}
        />
      </div>
    </div>
    </>
  );
}